import { z } from "zod";

import { carrierSchema } from "./carrier-schema.ts";

// PUT request Schemas //

// Endpoint: /api/carrier-selection/{quoteId}/update-prices
export const updateCarrierPriceBodySchema = z.object({
	Id: z.number().optional(),
	CarrierId: z.number(),
	CarrierPriceTypeId: z.number(),
	CarrierRate: z.number().nullable(),
	BrokerMargin: z.number(),
	CarrierQuoteId: z.string(),
	CarrierQuoteExpirationDate: z.string(),
	ServiceLevelId: z.number(),
	TransitDays: z.number().nullable(),
});

export type UpdateCarrierPriceBody = z.infer<
	typeof updateCarrierPriceBodySchema
>;

export const addManualPriceBodySchema = z.object({
	carrierRate: z.number(),
	customerRate: z.number(),
	markedUpCustomerRate: z.number().nullable().optional(),
	distributorRate: z.number().optional(),
	brokerMargin: z.number(),
	insuranceMarkup: z.number().nullable().optional(),
	maxLiabilityNew: z.number(),
	maxLiabilityUsed: z.number(),
	maxLiabilityOverride: z.number().nullable().optional(),
	carrierPriceType: z.object({
		id: z.number(),
		name: z.string(),
	}),
	serviceLevel: z.object({
		id: z.number(),
		name: z.string(),
	}),
	quoteId: z.number(),
	carrier: carrierSchema,
	carrierId: z.number(),
	carrierPriceTypeId: z.number(),
	carrierQuoteId: z.string(),
	carrierQuoteExpirationDate: z.string(),
	serviceLevelId: z.number(),
	transitDays: z.number().nullable(),
	carrierTotalAccessorialCharges: z.number().nullable(),
	carrierTotalAccessorialFuelSurcharges: z.number().nullable(),
	customerTotalAccessorialCharges: z.number().nullable(),
	customerTotalAccessorialFuelSurcharges: z.number().nullable(),
});

export type AddManualPriceBody = z.infer<typeof addManualPriceBodySchema>;
